import React from "react";
import urls from "../../../constants";

const TableHeader = ({ productConfigVariant }) => {
    return (
        <thead>
            <tr>
                {productConfigVariant?.map((item, index) => {
                    if (urls?.HIDDEN_FIELDS_GROUP?.includes(item?.groupId)) return null;
                    return (
                        <th key={index}>
                            {item?.variantName}
                        </th>
                    );
                })}
                <th>Unit Price</th>
                <th>CO Qty</th>
                <th>Released Qty</th>
                <th>Current Release</th>
                <th>Margin</th>
                <th>Total Price</th>
                <th>Notes</th>
                <th>Req Dely Date</th>
            </tr>
        </thead>
    );
};
export default TableHeader
